define('Components/ReinsuranceWidget/js/views/ReinsuranceWidgetInstanceView',[
    'jquery',
    'WidgetInstanceView',
    'app',
    'template!Components/ReinsuranceWidget/templates/reinsurance',
    'InternalLinkView',
    'router'
],
    function($, WidgetInstanceView, app, template, InternalLinkView, router){
        return WidgetInstanceView.extend({
            name: 'ReinsuranceWidgetInstanceView',
            events: {
                //'click .reinsurance-item__icon': 'toggleTooltip',
            },
            remove: function() {
                //$('body').off('click', this.remove);
                return this;
            },
            getTemplate:function () {
                return template
            },
            afterRender:function(){
                var links = InternalLinkView.initializeLinksOfView(this);
                //$('body').on('click', this.toggleTooltip);
                //console.log('afterRender links',links);
            },
            /*route: function (el) {
                var routeRegExp = new RegExp('(' + router.getBaseUrl() + ')(.*)'),
                    route = routeRegExp.exec(el.attr("href"))[2];
                return route==''?'/':route;
            },*/
            toggleTooltip:function(e) {
                /*
                var view = this,
                    $currentTarget = $(e.currentTarget);
                if ($currentTarget.is('body')) {
                    $('.reinsurance-widget .tooltip-icon.active').removeClass('active')
                    return
                }

                e.preventDefault()

                if ($currentTarget.find('.tooltip-icon.active').length) {
                    return router.go(this.route($currentTarget.parent('a')))
                }

                view.$('.tooltip-icon.active').removeClass('active')
                if ($currentTarget.is('.reinsurance-item__icon')) {
                    return $currentTarget.find('.tooltip-icon').addClass('active')
                }
                return
                */
            },
        })
});
